<template>
	<div
		class="container__radiobuttons"
		:class="{ disabled }"
	>
		<div class="container__radiobuttons__option !p-0">
			<input
				:id="id"
				v-model="model"
				type="radio"
				:name="name"
				:value="modelValue"
				:disabled="disabled"
			/>
			<label :for="id">{{ label }}</label>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const emit = defineEmits(['input'])

const props = defineProps({
	id: { type: String, required: false },
	label: { type: String },
	value: { type: [String, Boolean, Number] },
	name: { type: String },
	disabled: { type: Boolean },
	modelValue: { type: [String, Boolean, Number] },
})

const model = computed({
	get() {
		return props.value
	},
	set() {
		emit('input', props.modelValue)
	},
})
</script>

<style>
.container__radiobuttons {
	font-size: 0.8rem;
	color: #464947;
	user-select: none;
}

.container__radiobuttons > p {
	margin-bottom: 0.1rem;
}

.container__radiobuttons__option {
	display: flex;
	align-items: center;
	/* padding: 0px 15px; */
}

.container__radiobuttons__option > input {
	margin-right: 0.5rem;
	appearance: none;
	height: 15px;
	width: 15px;
	border-radius: 50%;
	position: relative;
	border: 2px solid #a9a9a9;
	outline: none;
}

.container__radiobuttons__option > input::before {
	position: absolute;
	content: '';
	left: 50%;
	top: 50%;
	transform: translate(-55%, -45%);
	height: 0;
	width: 0;
	border-radius: 50%;
	background-color: #34617e;
}

.container__radiobuttons__option > input:checked::before {
	height: 7px;
	width: 7px;
	transition: all 0.2s linear;
}

.container__radiobuttons__option > input:checked + label {
	font-weight: 700;
}

.container__radiobuttons.disabled {
	opacity: 40%;
	cursor: not-allowed;
}
</style>
